import { ProjectActionTypes, ProjectCountActionTypes, ProjectUsersAndGroupsActionTypes } from "./project-types";
import SortActionTypes from "../sort/sort-types";

const INITIAL_STATE = {
  projectQueryRedux: {
    userId: 0,
    sortBy: "",
    sortDesc: true,
    pageNumber: 1,
    pageSize: 10,
    filters: [{ column: "status", value: "active", type: null }],
  },
  groupProjectsBy: "Status",
  isFetchingProjects: false,
  errorMessage: "",
  projects: [],
  projectsUsers: [],
  projectsGroups: [],
  projectsGrouped: {
    active: [],
    completed: [],
    archived: [],
    urgent: [],
    high: [],
    medium: [],
    low: [],
    none: [],
  },
  projectsCount: {},
  selectedProjects: [],
  filteredAndSortedProjects: {
    active: [],
    completed: [],
    archived: [],
    urgent: [],
    high: [],
    medium: [],
    low: [],
    none: [],
  },
  showActive: true,
  showCompleted: false,
  showArchived: false,
  viewAllActiveRows: false,
  viewAllCompletedRows: false,
  viewAllArchivedRows: false,
};

const projectReducer = (state = INITIAL_STATE, action) => {

    let newSelectedProjects = state.selectedProjects;

    switch (action.type) {

        case ProjectActionTypes.RESET_PROJECTS:
            return {
                ...INITIAL_STATE
            }

        case ProjectActionTypes.SET_PROJECTS_QUERY:
            return {
                ...state,
                projectQueryRedux: action.payload
            }

        case ProjectActionTypes.FETCHING_PROJECTS_START:
            return {
                ...state,
                isFetchingProjects: true
            }
        case ProjectActionTypes.FETCHING_PROJECTS_SUCCESS:
            return {
                ...state,
                isFetchingProjects: false
            }
        case ProjectActionTypes.FETCHING_PROJECTS_FAILURE:
            return {
                ...state,
                isFetchingProjects: false,
                errorMessage: action.payload
            }
        case ProjectActionTypes.SET_PROJECTS:
            return {
                ...state,
                projects: action.payload
            }
        case ProjectUsersAndGroupsActionTypes.SET_PROJECTS_USERS:
            return {
                ...state,
                projectsUsers: action.payload
            }
        case ProjectUsersAndGroupsActionTypes.SET_PROJECTS_GROUPS:
            return {
                ...state,
                projectsGroups: action.payload
            }
        case ProjectActionTypes.SET_PROJECT_COUNTS:
                return {
                    ...state,
                    projectCounts: action.payload
                }
        case ProjectCountActionTypes.SET_PROJECTS_COUNT:
            return {
                ...state,
                projectsCount: action.payload
            }
        case ProjectActionTypes.ADD_SELECTED_PROJECT:
            return {
                ...state,
                selectedProjects: [
                    ...state.selectedProjects,
                    action.payload
                ],
            }
        case ProjectActionTypes.DELETE_SELECTED_PROJECT:
            newSelectedProjects.splice(newSelectedProjects.indexOf(action.payload), 1);

            return {
                ...state,
                selectedProjects: [
                    ...newSelectedProjects
                ],
            }
        case ProjectActionTypes.ADD_MULTIPLE_SELECTED_PROJECTS:
            return {
                ...state,
                selectedProjects: [
                    ...state.selectedProjects,
                    ...action.payload
                ],
            }
        case ProjectActionTypes.DELETE_MULTIPLE_SELECTED_PROJECTS:
            action.payload.forEach((projectId) => {
                newSelectedProjects.splice(newSelectedProjects.indexOf(projectId), 1)
            })

            return {
                ...state,
                selectedProjects: [
                    ...newSelectedProjects
                ],
            }
        case ProjectActionTypes.SET_SELECTED_PROJECT:
            return {
                ...state,
                selectedProjects: action.payload
            }

        case ProjectActionTypes.SET_GROUP_PROJECTS_BY:
            return {
                ...state,
                groupProjectsBy: action.payload
            }

        case ProjectActionTypes.SET_PROJECTS_GROUPED:
            return {
                ...state,
                projectsGrouped: action.payload
            }

        case ProjectActionTypes.SET_SHOW_ACTIVE:
            return {
                ...state,
                showActive: action.payload
            }

        case ProjectActionTypes.SET_SHOW_COMPLETED:
            return {
                ...state,
                showCompleted: action.payload
            }

        case ProjectActionTypes.SET_SHOW_ARCHIVED:
            return {
                ...state,
                showCompleted: action.payload
            }
        case ProjectActionTypes.SET_FILTERED_AND_SORTED_PROJECTS:
            return{
                ...state,
                filteredAndSortedProjects: action.payload
            }
        case SortActionTypes.CLEAR_ALL_GROUP_BYS:
            return {
                ...state,
                groupProjectsBy: 'Status',
            }

        default:
            return state;
    }
}

export default projectReducer;
